import React from 'react';
import { Play, Info } from 'lucide-react';
import { profileData, projects } from '../mockData';

const Hero = ({ onProjectClick }) => {
  const featuredProject = projects[0]; // McAfee - current role

  return (
    <div className="relative h-[80vh] w-full">
      <div className="absolute inset-0">
        <div className="relative w-full h-full">
          <img
            src="https://customer-assets.emergentagent.com/job_portfolio-films/artifacts/30ik9g3d_CLOUD%20%26%20DEVOPS%20ENGINEER.png"
            alt="Cloud & DevOps Engineer"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#141414] via-transparent to-transparent" />
        </div>
      </div>

      <div className="relative h-full flex items-center px-12 md:px-16">
        <div className="max-w-2xl space-y-6">
          <h1 className="text-5xl md:text-7xl font-bold text-white">
            {profileData.name}
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 font-semibold">
            {profileData.title}
          </p>
          <p className="text-base md:text-lg text-gray-400 leading-relaxed">
            {profileData.summary}
          </p>
          
          <div className="flex flex-wrap gap-2 mt-4">
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">AWS</span>
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">GCP</span>
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">Azure</span>
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">Kubernetes</span>
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">Terraform</span>
            <span className="px-3 py-1 bg-white/10 text-white text-sm rounded border border-white/30">CI/CD</span>
          </div>

          <div className="flex items-center space-x-4 pt-4">
            <button
              onClick={() => onProjectClick(featuredProject)}
              className="flex items-center space-x-2 bg-white text-black px-8 py-3 rounded font-semibold hover:bg-white/80 transition text-lg"
            >
              <Play size={24} fill="black" />
              <span>View Projects</span>
            </button>
            <button
              onClick={() => onProjectClick(featuredProject)}
              className="flex items-center space-x-2 bg-gray-500/50 text-white px-8 py-3 rounded font-semibold hover:bg-gray-500/70 transition text-lg"
            >
              <Info size={24} />
              <span>More Info</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;